import { render, staticRenderFns } from "./NewRegistration.vue?vue&type=template&id=5a9b2b9b&scoped=true&"
import script from "./NewRegistration.vue?vue&type=script&lang=tsx&"
export * from "./NewRegistration.vue?vue&type=script&lang=tsx&"
import style0 from "./NewRegistration.vue?vue&type=style&index=0&lang=less&"
import style1 from "./NewRegistration.vue?vue&type=style&index=1&id=5a9b2b9b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9b2b9b",
  null
  
)

export default component.exports